import { axiosGet, axiosPatch, axiosPost } from './axiosService';
const notificationsURL = 'Notifications/Me';
const messagesUrl = 'users/me/messages';

export class NotificationsService {
	getAllNotifications(currentPage = 1, perPage = 10) {
		return axiosGet(
			'',
			`${notificationsURL}/All?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

	getUnReadNotifications(currentPage = 1, perPage = 10) {
		return axiosGet(
			'',
			`${notificationsURL}/Unread?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

	markAsReadNotification(ids = []) {
		return axiosPost(ids, `${notificationsURL}/markasread`);
	}

	getAllMessages() {
		return axiosGet('', `${messagesUrl}`);
	}

	getUnReadMessages() {
		return axiosGet('', `${messagesUrl}/Unread`);
	}

	markAsReadMessage(form) {
		return axiosPatch(`${messagesUrl}/mark-as-read`, form);
	}

	markAsAllReadMessage() {
		return axiosPatch(`${messagesUrl}/mark-all-as-read`);
	}

}
